/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DashboardDoughnutModel
 */
export interface DashboardDoughnutModel {
  /**
   *
   * @type {string}
   * @memberof DashboardDoughnutModel
   */
  aiModel: string;
  /**
   *
   * @type {number}
   * @memberof DashboardDoughnutModel
   */
  totalValue: number;
}

/**
 * Check if a given object implements the DashboardDoughnutModel interface.
 */
export function instanceOfDashboardDoughnutModel(value: object): value is DashboardDoughnutModel {
  if (!('aiModel' in value) || value['aiModel'] === undefined) return false;
  if (!('totalValue' in value) || value['totalValue'] === undefined) return false;
  return true;
}

export function DashboardDoughnutModelFromJSON(json: any): DashboardDoughnutModel {
  return DashboardDoughnutModelFromJSONTyped(json, false);
}

export function DashboardDoughnutModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardDoughnutModel {
  if (json == null) {
    return json;
  }
  return {
    aiModel: json['ai_model'],
    totalValue: json['total_value'],
  };
}

export function DashboardDoughnutModelToJSON(value?: DashboardDoughnutModel | null): any {
  if (value == null) {
    return value;
  }
  return {
    ai_model: value['aiModel'],
    total_value: value['totalValue'],
  };
}
